import React, { FC } from 'react';
import clsx from 'clsx';
import { Toggle } from 'rsuite';

interface Props {
	localIsActive: boolean;
	handleInputChange: () => Promise<void>;
	isLoading: boolean
	isDisabled?: boolean;
}

export const ProviderActiveToggle: FC<Props> = (props) => {
	const { localIsActive, handleInputChange, isLoading, isDisabled } = props;

	return (
		<>
			<Toggle
				size="md"
				checked={localIsActive}
				className={clsx(localIsActive ? 'is-active' : '')}
				onChange={handleInputChange}
				disabled={isLoading || isDisabled}
			/>

		</>
	);
};
